import { useCallback, useContext, useEffect, useRef } from 'react';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useValidateDraftCondition } from '../../hooks/useValidateDraftCondition';
import { useViewerActions } from '../../hooks/useViewerActions';
import ConditionEditor from '../common/ConditionEditor';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewerConditionEditorContainer = styled.div.withConfig({
  displayName: "ViewerConditionEditor__ViewerConditionEditorContainer",
  componentId: "sc-1yob34y-0"
})(({
  theme,
  useOnePanel
}) => ({
  '.condition-box': {
    border: '1px solid transparent',
    backgroundColor: useOnePanel ? `${theme.color['fill-surface-recessed']}` : `${theme.color['fill-surface-default']} !important`
  }
}));
const ViewerConditionEditor = ({
  conditionPath,
  filterFamily,
  inputUse,
  isNestedOrHeader
}) => {
  const {
    draftCondition,
    props: {
      showAllFiltersInEditMode,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onCloseEditor
  } = useEditorActions();
  const {
    onConditionDeleteCancel
  } = useViewerActions();
  const {
    validateDraftCondition
  } = useValidateDraftCondition();
  const ref = useRef(null);
  const handleClickOutside = useCallback(evt => {
    if (showAllFiltersInEditMode && !(draftCondition !== null && draftCondition !== void 0 && draftCondition.conditionPath.equals(conditionPath))) {
      return;
    }
    if (ref.current && evt.target instanceof HTMLElement && !ref.current.contains(evt.target)) {
      onConditionDeleteCancel();
      onCloseEditor();
      validateDraftCondition();
    }
  }, [conditionPath, draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath, onCloseEditor, onConditionDeleteCancel, showAllFiltersInEditMode, validateDraftCondition]);
  useEffect(() => {
    // Need this element to prevent bug where clicking on popover will exit out of edit mode
    const el = Array.from(document.body.children).find(child => child.contains(ref.current));
    const timerId = setTimeout(() => {
      el === null || el === void 0 || el.addEventListener('click', handleClickOutside);
    }, 0);
    return () => {
      clearTimeout(timerId);
      el === null || el === void 0 || el.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside, showAllFiltersInEditMode]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ViewerConditionEditorContainer, {
      useOnePanel: !!useOnePanel,
      ref: ref,
      children: /*#__PURE__*/_jsx(ConditionEditor, {
        conditionPath: conditionPath,
        filterFamily: filterFamily,
        inputUse: inputUse,
        isNestedOrHeader: isNestedOrHeader
      })
    })
  );
};
export default ViewerConditionEditor;